import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pa-2" }
const _hoisted_2 = { style: {"width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_ExtensionTableItem = _resolveComponent("ExtensionTableItem")!
  const _component_ExtensionItemEdition = _resolveComponent("ExtensionItemEdition")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, { class: "d-flex align-center justify-space-between" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "" }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createElementVNode("h1", null, "Extensions", -1)
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "pl-2" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_primary, {
              id: "Senario",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialog = true))
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Ajouter")
              ])),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extensions, (ext, index) => {
          return (_openBlock(), _createBlock(_component_v_col, {
            cols: "4",
            key: `extension-${ext.id}`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ExtensionTableItem, _mergeProps({ ref_for: true }, ext, { onRemoved: _ctx.removeExtension }), null, 16, ["onRemoved"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
        title: "Ajouter une extension",
        actions: _ctx.dialogAction,
        onClose: _ctx.resetSelectedExtension
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ExtensionItemEdition, _mergeProps({ actions: _ctx.dialogAction }, _ctx.selectedExtension, { onUpdated: _ctx.updateExtensionItem }), null, 16, ["actions", "onUpdated"])
        ]),
        _: 1
      }, 8, ["modelValue", "actions", "onClose"])
    ])
  ]))
}